/**
 * feat-302 — audience applicability of a coverage cell (ANSWERS-BACKEND Q5).
 *
 * Pure helpers, kept OUT of curriculumCoverageService.ts on purpose: several
 * feat-241 suites replace that module wholesale with a jest factory, which would
 * turn these into `undefined` at render time.
 */
import type {
  CoverageCell,
  CoverageCrewMember,
  CoverageTrack,
} from '../../../services/curriculumCoverageService';

/** feat-302 F1 — the denominator of one cell's "N of M lessons": the cell's own
 *  `lessons_total` when the backend sends one, else the column's. */
export function cellLessonsTotal(cell: CoverageCell, track: CoverageTrack): number {
  return cell.lessons_total ?? track.lessons_total;
}

/** feat-302 — does this (crew, track) pair apply? A missing field means yes. */
export function cellApplies(cell: CoverageCell): boolean {
  return cell.applies !== false;
}

/** feat-302 — the denominator of "N of M tracks" for one crew member: the
 *  tracks that apply to them (every track, for an unscoped tenant). */
export function applicableTrackCount(member: CoverageCrewMember): number {
  return member.cells.filter(cellApplies).length;
}

/** feat-302 — ids of the tracks that do NOT apply to this crew member. */
export function notApplicableTrackIds(member: CoverageCrewMember): ReadonlySet<string> {
  return new Set(member.cells.filter((c) => !cellApplies(c)).map((c) => c.track_id));
}
